import { supabase } from '../../lib/supabase';
import { PRIVACY_VERSION } from '../../lib/legal';

const PENDING = 'kabinett-consent-pending';

/** Vor dem Absenden des Anmeldeformulars: Zustimmung merken, bis der Nutzer eingeloggt ist. */
export function rememberConsent() { try { localStorage.setItem(PENDING, PRIVACY_VERSION); } catch { /* privates Fenster */ } }
const pending = () => { try { return localStorage.getItem(PENDING) === PRIVACY_VERSION; } catch { return false; } };
const clearPending = () => { try { localStorage.removeItem(PENDING); } catch { /* egal */ } };

/** true = Zustimmung zur aktuellen Fassung liegt vor, false = fehlt, null = unbekannt (z. B. Tabelle noch nicht angelegt). */
export async function hasConsent(uid: string): Promise<boolean | null> {
  if (!supabase) return null;
  const { data, error } = await supabase.from('consents').select('accepted_at').eq('user_id', uid).eq('kind', 'privacy').eq('version', PRIVACY_VERSION).limit(1);
  if (error) { console.warn('[Kabinett] Zustimmung nicht abrufbar (Migration 0004 eingespielt?):', error.message); return null; }
  return (data ?? []).length > 0;
}

/** Zustimmung speichern. Datum setzt die Datenbank. Doppelte Einträge sind kein Fehler. */
export async function giveConsent(uid: string): Promise<string | null> {
  if (!supabase) return 'Nicht verbunden.';
  const { error } = await supabase.from('consents').insert({ user_id: uid, kind: 'privacy', version: PRIVACY_VERSION });
  if (error && error.code !== '23505') return error.message;
  clearPending();
  return null;
}

/** Nach dem Login: Zustimmung aus dem Anmeldeformular nachtragen, falls das Konto schon vorher existierte. */
export async function syncConsent(uid: string): Promise<boolean | null> {
  const has = await hasConsent(uid);
  if (has === false && pending()) return (await giveConsent(uid)) === null ? true : false;
  if (has) clearPending();
  return has;
}

/** Zeitpunkt der Zustimmung zur aktuellen Fassung (für die Kontoseite). */
export async function consentDate(uid: string): Promise<string | null> {
  if (!supabase) return null;
  const { data } = await supabase.from('consents').select('accepted_at').eq('user_id', uid).eq('kind', 'privacy').eq('version', PRIVACY_VERSION).limit(1);
  const r = (data ?? []) as { accepted_at: string }[];
  return r.length ? r[0].accepted_at : null;
}
